var map = {
	"./certificate.svg": 1553,
	"./checkmark.svg": 8359,
	"./circles.png": 9003,
	"./hero-robo.png": 3245,
	"./instructor-bolaji.png": 61,
	"./instructor-grace.png": 860,
	"./live.svg": 338,
	"./meet.png": 4223,
	"./native.svg": 4549,
	"./pg-entails-robo.png": 7175,
	"./practical.svg": 4461,
	"./project.svg": 3083,
	"./size.svg": 4511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2128;